import { Firebase } from '../../firebase.js'

const livestreams = {
  firestorePath: 'livestreams',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'livestreams',
  statePropName: 'data',
  namespaced: true, // automatically added
  sync: {
    // debounceTimerMs: 50
    // defaults to 1000
  },
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
      // define each field like so ↑ in an object here
    },
  },
  // you can also add state/getters/mutations/actions
  state: {
    current: {},
    stream: {},
    token: '',
    monitoringAlarms: [],
  },
  getters: {
    current: (state) => { return state.current },
    stream: (state) => { return state.stream },
    token: (state) => { return state.token },
    monitoringAlarms: (state) => state.monitoringAlarms,
    byId: (state) => (id) => id ? (state.data[id] || null) : null,
  },
  mutations: {
    setCurrentStreams(state, payload) {
      state.current = payload
    },
    setStream(state, payload) {
      state.stream = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setMonitoringAlarms(state, payload) {
      state.monitoringAlarms = Array.isArray(payload) ? payload : []
    }
  },
  actions: {
    getCurrent({ commit }) {
      var publish = Firebase.app().functions('europe-west2').httpsCallable('currentStreams')
      return publish()
        .then(function (result) {
          // console.log(result)
          commit('setCurrentStreams', result.data.jobs || [])
        })
        .catch((error) => {
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(error)
          commit('setCurrentStreams', [])
        })
    },
    getStream({ commit }, payload) {
      const id = typeof payload === 'string' ? payload : payload.id
      const body =
        typeof payload === 'string'
          ? { id }
          : { id, ...(payload.matchId ? { matchId: payload.matchId } : {}) }
      var publish = Firebase.app().functions('europe-west2').httpsCallable('getStream')
      publish(body)
        .then(function (result) {
          console.log('[livestreams/getStream] callable response:', result && result.data)
          const job = result.data.job
          commit('setStream', job)
          if (job && job.provider === 'aws') {
            commit('setToken', '')
            return
          }
          var publishToken = Firebase.app()
            .functions('europe-west2')
            .httpsCallable('playbackToken')
          return publishToken({ streamID: id }).then((tokenResult) => {
            commit('setToken', (tokenResult.data && tokenResult.data.playback_token) || '')
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    activateStream(context, payload) {
      var publish = Firebase.app()
        .functions('europe-west2')
        .httpsCallable('activateStream')
      return publish(payload)
    },
    deactivateStream(context, payload) {
      var publish = Firebase.app()
        .functions('europe-west2')
        .httpsCallable('deactivateStream')
      return publish(payload)
    },
    getLivestreamAlarms({ commit }, payload) {
      const streamId = typeof payload === 'string' ? payload : payload && payload.streamId
      const limit = payload && payload.limit ? payload.limit : 20
      if (!streamId) {
        commit('setMonitoringAlarms', [])
        return Promise.resolve([])
      }
      var publish = Firebase.app()
        .functions('europe-west2')
        .httpsCallable('getLivestreamAlarms')
      return publish({ streamId, limit })
        .then((result) => {
          const alarms = (result && result.data && result.data.alarms) || []
          commit('setMonitoringAlarms', alarms)
          return alarms
        })
        .catch((error) => {
          console.log(error)
          commit('setMonitoringAlarms', [])
          return []
        })
    }
  }
}
export default livestreams